<app-login [data]="data" (closeModal)="dialogRef.close()"></app-login>
